import {
  WSElement,
  WSFlexBox,
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar,
  WSPanel,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { useQueryPayee } from "../../../../../query/payee/queries/useQueryPayee";
import { useQueryPayeeEngagementByPayeeId } from "../../../../../query/payeeEngagements/queries/useQueryPayeeEngagementByPayeeId";
import { WSQueries } from "../../../../../query/WSQuery";
import { FieldView } from "../../../../../shared/components/FieldView/FieldView";
import { ResourceHistory } from "../../../../../shared/components/ResourceHistory";
import { usePayeeEngagementHistoryResources } from "../../../hooks/usePayeeEngagementHistoryResources";
import { getPayeeName } from "../../../selectors/getPayeeNames";
import { selectorPayerPayeeEngagementName } from "../../../selectors/selectorPayerPayeeEngagementName";
import {
  PAYEES_ROOT_PATH,
  useGoToEngagementDetails,
  useGoToPayeeDetails
} from "../../../utils";

export const RoutePayeeEngagementHistory: React.FC<
  RouteComponentProps<{ payeeId: string; engagementId: string }>
> = ({
  match: {
    params: { payeeId, engagementId }
  },
  history
}) => {
  const queryPayee = useQueryPayee(payeeId);
  const queryEngagement = useQueryPayeeEngagementByPayeeId(
    payeeId,
    engagementId
  );
  const goToPayeeDetails = useGoToPayeeDetails();
  const goToEngagementDetails = useGoToEngagementDetails();
  const historyResources = usePayeeEngagementHistoryResources(engagementId);

  return (
    <WSPage>
      <WSQueries queries={{ queryPayee, queryEngagement }}>
        {({ queryPayeeData: payee, queryEngagementData: engagement }) => {
          const engagementName = selectorPayerPayeeEngagementName(
            engagement,
            true
          );

          return (
            <>
              <WSPageToolbar
                title="Engagement history"
                breadcrumbs={[
                  {
                    label: "Contractors",
                    onClick: () => {
                      history.push(PAYEES_ROOT_PATH);
                    }
                  },
                  {
                    label: getPayeeName(payee),
                    onClick: () => {
                      goToPayeeDetails(payeeId);
                    }
                  },
                  {
                    label: engagementName || "Engagement",
                    onClick: () => {
                      goToEngagementDetails(payeeId, engagementId);
                    }
                  },
                  {
                    label: "Engagement history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <WSElement>
                      <WSElement>
                        <WSSectionToolbar title="Engagement information" />
                        <WSPanel>
                          <WSFlexBox gap="XL">
                            <FieldView
                              label="Engagement name"
                              value={engagementName}
                            />
                          </WSFlexBox>
                        </WSPanel>
                      </WSElement>
                    </WSElement>

                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
